export enum WhoopsReason {
  default = 'default',
  noProducts = 'noProducts',
  pageNotFound = 'notFound',
  serverError = 'serverError',
  loadError = 'loadError',
  ssoError = 'ssoError',
  adminSsoError = 'adminSsoError',
  existingAppleAccount = 'existingAppleAccount',
  existingGoogleAccount = 'existingGoogleAccount',
  unverifiedAccount = 'unverifiedAccount',
}

export type WhoopsProps = {
  reason: WhoopsReason;
  children?: React.ReactNode;
};
